import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixInnovationAssistantStatsV2WixAssistantStatisticsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-assistant-stats',
        destPath: '/api',
      },
      {
        srcPath: '/wix-assistant-stats',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/innovation/assistant/v2/statistics',
        destPath: '/v2/statistics',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/innovation/assistant/v2/statistics',
        destPath: '/v2/statistics',
      },
    ],
    _: [
      {
        srcPath: '/innovation/assistant/v2/statistics',
        destPath: '/v2/statistics',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_assistant-stats_statistics';

/** Retrieves aggregated AI Site-Chat statistics for the authenticated site. */
export function getStatistics(payload: object): RequestOptionsFactory<any> {
  function __getStatistics({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.innovation.assistant.v2.statistics',
      method: 'GET' as any,
      methodFqn:
        'wix.innovation.assistant.stats.v2.WixAssistantStatistics.GetStatistics',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixInnovationAssistantStatsV2WixAssistantStatisticsUrl({
        protoPath: '/v2/statistics',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'statistics.dailies.date' }],
          },
        ]),
    };

    return metadata;
  }

  return __getStatistics;
}
